/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectHotelName } from '../../../selectors';

/**
 * Displays the selected hotel information in the visual header.
 * @param {Object} props
 * @param {boolean} [props.isWorkbookHotelComparison=false] - Determines whether the component should render comparison details.
 * @param {Object} [props.comparisonHotel={}] - The hotel object used for comparison when comparison mode is enabled.
 * @returns {JSX.Element}
 */
const HotelHeaderInfo = ({ isWorkbookHotelComparison = false, comparisonHotel = {} }) => {
  const selectedHotelName = useSelector(selectHotelName);
  //
  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      height={isWorkbookHotelComparison ? 40 : 20}
      paddingLeft={4}
      sx={{ backgroundColor: 'white', fontWeight: 'bold' }}
    >
      {isWorkbookHotelComparison ? (
        <Grid container direction="row" justifyContent="space-between">
          <Grid item xs={12}>
            {`Selection Hotel ${
              selectedHotelName && 'hotels' in selectedHotelName ? 'Set' : ''
            } (A) : ${selectedHotelName?.label}`}
            <br />
            {`Comparison Hotel ${
              comparisonHotel && 'hotels' in comparisonHotel ? 'Set' : ''
            } (B) : ${comparisonHotel?.label}`}
          </Grid>
        </Grid>
      ) : (
        <Grid item xs={12}>
          {`Hotel ${selectedHotelName && 'hotels' in selectedHotelName ? 'Set' : ''} : ${
            selectedHotelName?.label
          }`}
        </Grid>
      )}
    </Grid>
  );
};
//
export default HotelHeaderInfo;
